import { useState } from 'react';
import { ErrorBanner, Textarea } from '@/components/form';
import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';

/** Approve (comment optional), reject (comment required) or ask for approval (note optional). */
export function DecisionDialog({
  open,
  title,
  description,
  confirm,
  required,
  label,
  pending,
  error,
  onConfirm,
  onClose,
}: {
  open: boolean;
  title: string;
  description: string;
  confirm: string;
  required?: boolean;
  label: string;
  pending?: boolean;
  error?: string | null;
  onConfirm: (text: string) => void;
  onClose: () => void;
}) {
  const [text, setText] = useState('');
  const missing = required && !text.trim();
  return (
    <Dialog
      open={open}
      onOpenChange={(o) => {
        if (!o) {
          setText('');
          onClose();
        }
      }}
    >
      <DialogContent data-testid="decision-dialog">
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
          <DialogDescription>{description}</DialogDescription>
        </DialogHeader>
        {error ? <ErrorBanner>{error}</ErrorBanner> : null}
        <label className="space-y-1 text-sm">
          <span className="font-medium">
            {label}
            {required ? ' *' : ' (optional)'}
          </span>
          <Textarea
            aria-label={label}
            maxLength={2000}
            value={text}
            onChange={(e) => setText(e.target.value)}
          />
        </label>
        <DialogFooter>
          <Button variant="outline" onClick={onClose}>
            Cancel
          </Button>
          <Button
            disabled={pending || missing}
            onClick={() => onConfirm(text.trim())}
            variant={confirm.startsWith('Reject') ? 'destructive' : 'default'}
          >
            {pending ? 'Saving…' : confirm}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
